import * as THREE from 'three';
import { renderConfig } from '../config';

export class Renderer {
  readonly webgl: THREE.WebGLRenderer;

  constructor(canvas: HTMLCanvasElement, exposure = 1.0) {
    this.webgl = new THREE.WebGLRenderer({
      canvas,
      antialias: true,
      powerPreference: 'high-performance'
    });
    this.webgl.outputColorSpace = THREE.SRGBColorSpace;
    this.webgl.toneMapping = THREE.ACESFilmicToneMapping;
    this.webgl.toneMappingExposure = exposure;
    this.webgl.setClearColor(renderConfig.clearColor, 1);
    this.applyViewport(window.innerWidth, window.innerHeight);
  }

  resize(width: number, height: number): void {
    this.applyViewport(width, height);
  }

  dispose(): void {
    this.webgl.dispose();
  }

  private applyViewport(width: number, height: number): void {
    this.webgl.setPixelRatio(
      Math.min(window.devicePixelRatio, renderConfig.pixelRatioCap)
    );
    this.webgl.setSize(width, height, false);
  }
}
